export default () => {
  const scrollToTop = (top = 0) => {
    if (import.meta.client) {
      window.scroll({
        top,
      });
    }
  };

  return {
    scrollToTop,
  };
};
